define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/action/AggregateBaseController",
	"csi/table/NewMixin"
], function(array,declare,csi,AggregateBaseController,NewMixin) {

	return declare([AggregateBaseController, NewMixin], {
		constructor: function(/*Object*/params) {
			// summary: reset node since they are being created
			this.m_urlNode = null;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add appended rows to request
			return this.inherited(arguments, [urlsNew.concat(this.urlsAppended)]);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return csi.transform(this.urlsAppended, function(url) { return this.m_cache.getNode(url); }, this) || [];
		},

		preProcess: function() {
			// summary: call mixin before continuing
			if (this._newPreProcess()) {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: remove deselected nodes before adding new ones
			var	dfd = this.inherited(arguments);
			if (dfd) return dfd;
			
			var	view = this.widget;
			var	refNode;

			array.forEach(this.urlsRemoved, function(url) {
				if (refNode = view.getRefNodeByUrl(url)) {
					view.deleteRow(refNode);
					--this.nNew;
				}
			}, this);

			this._newPostProcess();
		}
	});
});